import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { SecondaryButton } from "../../../layout/Button/Button";
import { HeadlineFigureWidget } from "./HeadlineFigureWidget";
import { useFetch } from "../../../../core/components/crud/contexts/fetch.context";
import { ActiveProgramStats } from "common/build/api-parameters/users";
import { SpinWhileFetching } from "../../../common/SpinWhileFetching";
import { VTextLink } from "../../../common/VTextLink";
import { useAuth } from "../../../../contexts/auth.context";
import { SCHOOL_CREATE_PROGRAMME_PATH } from "../../../../hooks/useNextSession";

export const ActiveProgrammesHeadlineWidget: FC<{ isFacilitator: boolean }> = ({ isFacilitator }) => {
    const { user } = useAuth();
    const { item } = useFetch<ActiveProgramStats>();
    const count = item?.programmes.length || 0;
    const hasNoActiveProgrammes = count === 0;
    const schedulePath = user?.isSchool ? SCHOOL_CREATE_PROGRAMME_PATH : "/programmes/add";
    const viewPath = user?.isSchool ? "/classrooms" : "/programmes";
    return (
        <HeadlineFigureWidget header={isFacilitator ? "Your Programmes" : "Active Programmes"}>
            <Box>
                <SpinWhileFetching>
                    <Typography variant="h2">{count}</Typography>
                </SpinWhileFetching>
            </Box>
            <Box>
                {!isFacilitator && (
                    <>
                        {hasNoActiveProgrammes ? (
                            <VTextLink to={schedulePath}>
                                <SecondaryButton fullWidth>
                                    {user?.isSchool ? "Create programme" : "Schedule Programme"}
                                </SecondaryButton>
                            </VTextLink>
                        ) : (
                            <VTextLink to={viewPath}>
                                <SecondaryButton fullWidth>
                                    {user?.isSchool ? "View classrooms" : "View Programmes"}
                                </SecondaryButton>
                            </VTextLink>
                        )}
                    </>
                )}
            </Box>
        </HeadlineFigureWidget>
    );
};
